import React from "react";


import DeleteIcon from "../../../../assets/delete-modal-icon.svg"

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  deleteType,
  itemName = ""
}) => {
  if (!isOpen) return null;

  const getTitle = () => {
    return deleteType === "item" ? "Remove Product" : "Clear Cart";
  };

  const getMessage = () => {
    if (deleteType === "item") {
      return "Are you sure you want to remove this product from cart?";
    }
    return "Are you sure you want to clear all items from cart?";
  };

  const getConfirmButtonText = () => {
    return deleteType === "item" ? "Remove" : "Clear Cart";
  };

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="modal-icon">
          <img src={DeleteIcon} alt="Delete" />
        </div>
        <h3 className="modal-title">{getTitle()}</h3>
        <p className="modal-message">
          {getMessage()}
          <br />
          This action cannot be undone.
        </p>
        <div className="modal-actions">
          <button className="modal-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-delete-btn" onClick={onConfirm}>
            {getConfirmButtonText()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
